// 用户管理

import Layout from './layout'

export default {
  path: '/user-manage',
  name: 'userManage',
  component: Layout,
  redirect: 'userManageList',
  badge: 'applyagentMsg',
  alwaysShow: true,
  meta: { title: '用户管理', icon: 'userm', groupTitle: '通用', roles: ['taoke'] },
  children: [
    {
      path: 'list',
      name: 'userManageList',
      component: () => import(/* webpackChunkName: "userManageList" */ '@v/userManage/list'),
      meta: { title: '用户列表' },
    },
    {
      path: 'request',
      badge: 'applyagentMsg',
      component: () => import(/* webpackChunkName: "commission" */ '@v/distributionManage/request'),
      name: 'DistributionManageRequest',
      meta: { title: '代理申请' },
    },
    // {
    //   path: 'level',
    //   name: 'userManageLevel',
    //   component: () => import(/* webpackChunkName: "userManageLevel" */ '@v/userManage/level'),
    //   meta: { title: '等级管理' }
    // },
    {
      path: 'lower',
      name: 'userManageLower',
      hidden: true,
      component: () => import(/* webpackChunkName: "userManageLower" */ '@v/userManage/lower'),
      meta: { title: '查看下级' },
    },
  ],
}